// extracted by mini-css-extract-plugin
export default {"contentWrapper":"qDww_","collapsible":"_3PKUU","content":"IBByf"};